/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 858:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill
// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505
(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript() {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript'); // for chrome

    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript;
    } // for other browsers with native support for currentScript


    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript;
    } // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace


    try {
      throw new Error();
    } catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
          ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
          stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
          scriptLocation = stackDetails && stackDetails[1] || false,
          line = stackDetails && stackDetails[2] || false,
          currentLocation = document.location.href.replace(document.location.hash, ''),
          pageSource,
          inlineScriptSourceRegExp,
          inlineScriptSource,
          scripts = document.getElementsByTagName('script'); // Live NodeList collection

      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }

      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        } // If src matches, return the script tag


        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        } // If inline source matches, return the script tag


        if (scriptLocation === currentLocation && scripts[i].innerHTML && scripts[i].innerHTML.trim() === inlineScriptSource) {
          return scripts[i];
        }
      } // If no match, return null


      return null;
    }
  }

  ;
  return getCurrentScript;
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ entry_lib; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__(858)
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/VueFriendlyCaptcha.vue?vue&type=template&id=4ad1c2d2&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"captcha",staticClass:"vue-friendly-captcha frc-captcha",class:{ dark: _vm.dark }})}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/friendly-challenge/index.js
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// Adapted from the base64-arraybuffer package implementation
// (https://github.com/niklasvh/base64-arraybuffer, MIT licensed)
var CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var EQ_CHAR = "=".charCodeAt(0); // Use a lookup table to find the index.

var lookup = new Uint8Array(256);

for (var i = 0; i < CHARS.length; i++) {
  lookup[CHARS.charCodeAt(i)] = i;
}

function encode(bytes) {
  var len = bytes.length;
  var base64 = "";

  for (var _i = 0; _i < len; _i += 3) {
    var b0 = bytes[_i + 0];
    var b1 = bytes[_i + 1];
    var b2 = bytes[_i + 2];
    base64 += CHARS.charAt(b0 >>> 2);
    base64 += CHARS.charAt((b0 & 3) << 4 | b1 >>> 4);
    base64 += CHARS.charAt((b1 & 15) << 2 | b2 >>> 6);
    base64 += CHARS.charAt(b2 & 63);
  }

  if (len % 3 === 2) {
    base64 = base64.substring(0, base64.length - 1) + "=";
  } else if (len % 3 === 1) {
    base64 = base64.substring(0, base64.length - 2) + "==";
  }

  return base64;
}

function decode(base64) {
  var len = base64.length;
  var bufferLength = len * 3 >>> 2; // * 0.75

  if (base64.charCodeAt(len - 1) === EQ_CHAR) bufferLength--;
  if (base64.charCodeAt(len - 2) === EQ_CHAR) bufferLength--;
  var bytes = new Uint8Array(bufferLength);

  for (var _i2 = 0, p = 0; _i2 < len; _i2 += 4) {
    var encoded1 = lookup[base64.charCodeAt(_i2 + 0)];
    var encoded2 = lookup[base64.charCodeAt(_i2 + 1)];
    var encoded3 = lookup[base64.charCodeAt(_i2 + 2)];
    var encoded4 = lookup[base64.charCodeAt(_i2 + 3)];
    bytes[p++] = encoded1 << 2 | encoded2 >> 4;
    bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
    bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
  }

  return bytes;
}

var css = '.frc-captcha *{margin:0;padding:0;border:0;text-align:initial;border-radius:px;filter:none!important;transition:none!important;font-weight:400;font-size:14px;line-height:1.2;text-decoration:none;background-color:initial;color:#222}.frc-captcha{position:relative;width:312px;border:1px solid #f4f4f4;padding-bottom:12px;background-color:#fff}.frc-captcha b{font-weight:700}.frc-container{display:flex;align-items:center;min-height:52px}.frc-icon{fill:#222;stroke:#222;flex-shrink:0;margin:8px 8px 0}.frc-icon.frc-warning{fill:#c00}.frc-success .frc-icon{animation:1s ease-in both frc-fade-in}.frc-content{white-space:nowrap;display:flex;flex-direction:column;margin:4px 6px 0 0;overflow-x:auto;flex-grow:1}.frc-banner{position:absolute;bottom:0;right:6px;line-height:1}.frc-banner *{font-size:10px;opacity:.8;text-decoration:none}.frc-progress{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:3px 0;height:4px;border:none;background-color:#eee;color:#222;width:100%;transition:.5s linear}.frc-progress::-webkit-progress-bar{background:#eee}.frc-progress::-webkit-progress-value{background:#222}.frc-progress::-moz-progress-bar{background:#222}.frc-button{cursor:pointer;padding:2px 6px;background-color:#f1f1f1;border:1px solid transparent;text-align:center;font-weight:600;text-transform:none}.frc-button:focus{border:1px solid #333}.frc-button:hover{background-color:#ddd}.frc-captcha-solution{display:none}.frc-err-url{text-decoration:underline;font-size:.9em}.dark.frc-captcha{color:#fff;background-color:#222;border-color:#333}.dark.frc-captcha *{color:#fff}.dark.frc-captcha button{background-color:#444}.dark .frc-icon{fill:#fff;stroke:#fff}.dark .frc-progress{background-color:#444}.dark .frc-progress::-webkit-progress-bar{background:#444}.dark .frc-progress::-webkit-progress-value{background:#ddd}.dark .frc-progress::-moz-progress-bar{background:#ddd}@keyframes frc-fade-in{from{opacity:0}to{opacity:1}}'; // This is not an enum to save some bytes in the output bundle.

var SOLVER_TYPE_JS = 1;
var CHALLENGE_SIZE_BYTES = 128; // @ts-ignore

var loaderSVG = "<circle cx=\"12\" cy=\"12\" r=\"8\" stroke-width=\"3\" stroke-dasharray=\"15 10\" fill=\"none\" stroke-linecap=\"round\" transform=\"rotate(0 12 12)\"><animateTransform attributeName=\"transform\" type=\"rotate\" repeatCount=\"indefinite\" dur=\"0.9s\" values=\"0 12 12;360 12 12\"/></circle>";
var errorSVG = "<path d=\"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z\"/>";
/**
 * Base template used for all widget states
 * The reason we use raw string interpolation here is so we don't have to ship something like lit-html.
 */

function getTemplate(fieldName, svgContent, textContent, solutionString, buttonText) {
  var progress = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  var debugData = arguments.length > 6 ? arguments[6] : undefined;
  var additionalContainerClasses = arguments.length > 7 ? arguments[7] : undefined;
  return "<div class=\"frc-container".concat(additionalContainerClasses ? " " + additionalContainerClasses : "", "\">\n<svg class=\"frc-icon\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" height=\"32\" width=\"32\" viewBox=\"0 0 24 24\">").concat(svgContent, "</svg>\n<div class=\"frc-content\">\n    <span class=\"frc-text\" ").concat(debugData ? "title=\"".concat(debugData, "\"") : "", ">").concat(textContent, "</span>\n    ").concat(buttonText ? "<button type=\"button\" class=\"frc-button\">".concat(buttonText, "</button>") : "", "\n    ").concat(progress ? "<progress class=\"frc-progress\" value=\"0\">0%</progress>" : "", "\n</div>\n</div><span class=\"frc-banner\"><a href=\"https://friendlycaptcha.com/\" rel=\"noopener\" target=\"_blank\"><b>Friendly</b>Captcha \u21D7</a></span>\n<input name=\"").concat(fieldName, "\" class=\"frc-captcha-solution\" type=\"hidden\" value=\"").concat(solutionString, "\">");
}
/**
 * Used when the widget is ready to start solving.
 */


function getReadyHTML(fieldName, l) {
  return getTemplate(fieldName, "<path d=\"M17,11c0.34,0,0.67,0.04,1,0.09V6.27L10.5,3L3,6.27v4.91c0,4.54,3.2,8.79,7.5,9.82c0.55-0.13,1.08-0.32,1.6-0.55 C11.41,19.47,11,18.28,11,17C11,13.69,13.69,11,17,11z\"/><path d=\"M17,13c-2.21,0-4,1.79-4,4c0,2.21,1.79,4,4,4s4-1.79,4-4C21,14.79,19.21,13,17,13z M17,14.38\"/>", l.text_ready, ".UNSTARTED", l.button_start, false);
}
/**
 * Used when the widget is retrieving a puzzle
 */


function getFetchingHTML(fieldName, l) {
  return getTemplate(fieldName, loaderSVG, l.text_fetching, ".FETCHING", undefined, true);
}
/**
 * Used when the solver is running, displays a progress bar.
 */


function getRunningHTML(fieldName, l) {
  return getTemplate(fieldName, loaderSVG, l.text_solving, ".UNFINISHED", undefined, true);
}

function getDoneHTML(fieldName, l, solution, data) {
  var timeData = "Completed: ".concat(data.t.toFixed(0), "s (").concat((data.h / data.t * 0.001).toFixed(0), "K/s)").concat(data.solver === SOLVER_TYPE_JS ? " JS Fallback" : "");
  return getTemplate(fieldName, "<title>".concat(timeData, "</title><path d=\"M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z\"></path>"), l.text_completed, solution, undefined, false, timeData, "frc-success");
}

function getExpiredHTML(fieldName, l) {
  return getTemplate(fieldName, errorSVG, l.text_expired, ".EXPIRED", l.button_restart);
}

function getErrorHTML(fieldName, l, errorDescription) {
  var recoverable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var headless = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return getTemplate(fieldName, errorSVG, "<b>".concat(l.text_error, "</b><br>").concat(errorDescription), headless ? ".HEADLESS_ERROR" : ".ERROR", recoverable ? l.button_retry : undefined);
}
/**
 * Injects the style if no #frc-style element is already present
 * (to support custom stylesheets)
 */


function injectStyle() {
  if (!document.querySelector("#frc-style")) {
    var styleSheet = document.createElement("style");
    styleSheet.id = "frc-style";
    styleSheet.innerHTML = css;
    document.head.appendChild(styleSheet);
  }
}
/**
 * @param element parent element of friendlycaptcha
 * @param progress value between 0 and 1
 */


function updateProgressBar(element, data) {
  var p = element.querySelector(".frc-progress");
  var perc = (data.i + 1) / data.n;

  if (p) {
    p.value = perc;
    p.innerText = perc.toFixed(2) + "%";
    p.title = data.i + 1 + "/" + data.n + " (" + (data.h / data.t * 0.001).toFixed(0) + "K/s)";
  }
}
/**
 * Traverses parent nodes until a <form> is found, returns null if not found.
 */


function findParentFormElement(element) {
  while (element.tagName !== "FORM") {
    element = element.parentElement;

    if (!element) {
      return null;
    }
  }

  return element;
}
/**
 * Add listener to specified element that will only fire once on focus.
 */


function executeOnceOnFocusInEvent(element, listener) {
  element.addEventListener("focusin", listener, {
    once: true,
    passive: true
  });
} // Defensive init to make it easier to integrate with Gatsby and friends.


var nav;
var ua;

if (typeof navigator !== "undefined") {
  nav = navigator;
  ua = nav.userAgent.toLowerCase();
}
/**
 * Headless browser detection on the clientside is imperfect. One can modify any clientside code to disable or change this check,
 * and one can spoof whatever is checked here. However, that doesn't make it worthless: it's yet another hurdle for spammers and
 * it stops unsophisticated scripters from making any request whatsoever.
 */


function isHeadless() {
  var correctPrototypes = true;

  try {
    correctPrototypes = PluginArray.prototype === nav.plugins.__proto__;

    if (nav.plugins.length > 0) {
      correctPrototypes = correctPrototypes && Plugin.prototype === nav.plugins[0].__proto__;
    }
  } catch (e) {
    /* Do nothing, this browser misbehaves in mysterious ways */
  }

  return (//tell-tale bot signs
    ua.indexOf("headless") !== -1 || nav.appVersion.indexOf("Headless") !== -1 || ua.indexOf("bot") !== -1 || // http://www.useragentstring.com/pages/useragentstring.php?typ=Browser
    ua.indexOf("crawl") !== -1 || // Only IE5 has two distributions that has this on windows NT.. so yeah.
    nav.webdriver === true || !nav.language || nav.languages !== undefined && !nav.languages.length || // IE 11 does not support NavigatorLanguage.languages https://developer.mozilla.org/en-US/docs/Web/API/NavigatorLanguage/languages
    !correctPrototypes
  );
}
/**
 * Maps a value between 0 and 255 to a difficulty threshold (as uint32)
 * Difficulty 0 maps to 99.99% probability of being right on the first attempt
 * Anything above 250 needs 2^32 tries on average to solve.
 * 150 to 180 seems reasonable
 */


function difficultyToThreshold(value) {
  if (value > 255) {
    value = 255;
  } else if (value < 0) {
    value = 0;
  }

  return Math.pow(2, (255.999 - value) / 8.0) >>> 0;
}

var PUZZLE_EXPIRY_OFFSET = 13;
var NUMBER_OF_PUZZLES_OFFSET = 14;
var PUZZLE_DIFFICULTY_OFFSET = 15;

function getPuzzleSolverInputs(puzzleBuffer, numPuzzles) {
  var startingPoints = [];

  for (var _i3 = 0; _i3 < numPuzzles; _i3++) {
    var input = new Uint8Array(CHALLENGE_SIZE_BYTES);
    input.set(puzzleBuffer);
    input[120] = _i3;
    startingPoints.push(input);
  }

  return startingPoints;
}

function decodeBase64Puzzle(base64Puzzle) {
  var parts = base64Puzzle.split(".");
  var puzzle = parts[1];
  var arr = decode(puzzle);
  return {
    signature: parts[0],
    base64: puzzle,
    buffer: arr,
    n: arr[NUMBER_OF_PUZZLES_OFFSET],
    threshold: difficultyToThreshold(arr[PUZZLE_DIFFICULTY_OFFSET]),
    expiry: arr[PUZZLE_EXPIRY_OFFSET] * 300000
  };
}

function getPuzzle(_x, _x2, _x3) {
  return _getPuzzle.apply(this, arguments);
}
/**
 * Retries given request with exponential backoff (starting with 1000ms delay, multiplying by 4 every time)
 * @param url Request (can be string url) to fetch
 * @param opts Options for fetch
 * @param n Number of times to attempt before giving up.
 */


function _getPuzzle() {
  _getPuzzle = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(urlsSeparatedByComma, siteKey, lang) {
    var urls, _i10, response, json, _json;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            urls = urlsSeparatedByComma.split(",");
            _i10 = 0;

          case 2:
            if (!(_i10 < urls.length)) {
              _context2.next = 36;
              break;
            }

            _context2.prev = 3;
            _context2.next = 6;
            return fetchAndRetryWithBackoff(urls[_i10] + "?sitekey=" + siteKey, {
              headers: [["x-frc-client", "js-0.9.0"]],
              mode: "cors"
            }, 2);

          case 6:
            response = _context2.sent;

            if (!response.ok) {
              _context2.next = 14;
              break;
            }

            _context2.next = 10;
            return response.json();

          case 10:
            json = _context2.sent;
            return _context2.abrupt("return", json.data.puzzle);

          case 14:
            _json = void 0;
            _context2.prev = 15;
            _context2.next = 18;
            return response.json();

          case 18:
            _json = _context2.sent;
            _context2.next = 23;
            break;

          case 21:
            _context2.prev = 21;
            _context2.t0 = _context2["catch"](15);

          case 23:
            if (!(_json && _json.errors && _json.errors[0] === "endpoint_not_enabled")) {
              _context2.next = 25;
              break;
            }

            throw Error("Endpoint not allowed (".concat(response.status, ")"));

          case 25:
            if (!(_i10 === urls.length - 1)) {
              _context2.next = 27;
              break;
            }

            throw Error("Response status ".concat(response.status, " ").concat(response.statusText));

          case 27:
            _context2.next = 33;
            break;

          case 29:
            _context2.prev = 29;
            _context2.t1 = _context2["catch"](3);
            console.error("[FriendlyCaptcha]:", _context2.t1);
            throw Error("".concat(lang.text_fetch_error, " <a class=\"frc-err-url\" href=\"").concat(urls[_i10], "\">").concat(urls[_i10], "</a>"));

          case 33:
            _i10++;
            _context2.next = 2;
            break;

          case 36:
            throw Error("Internal error");

          case 37:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[3, 29], [15, 21]]);
  }));
  return _getPuzzle.apply(this, arguments);
}

function fetchAndRetryWithBackoff(_x4, _x5, _x6) {
  return _fetchAndRetryWithBackoff.apply(this, arguments);
} // English


function _fetchAndRetryWithBackoff() {
  _fetchAndRetryWithBackoff = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url, opts, n) {
    var time;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            time = 1000;
            return _context4.abrupt("return", fetch(url, opts).catch( /*#__PURE__*/function () {
              var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(error) {
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!(n === 0)) {
                          _context3.next = 2;
                          break;
                        }

                        throw error;

                      case 2:
                        _context3.next = 4;
                        return new Promise(function (r) {
                          return setTimeout(r, time);
                        });

                      case 4:
                        time *= 4;
                        return _context3.abrupt("return", fetchAndRetryWithBackoff(url, opts, n - 1));

                      case 6:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function (_x7) {
                return _ref.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchAndRetryWithBackoff.apply(this, arguments);
}

var LANG_EN = {
  text_init: "Initializing..",
  text_ready: "Anti-Robot Verification",
  button_start: "Click to start verification",
  text_fetching: "Fetching Challenge",
  text_solving: "Verifying you are human..",
  text_completed: "I am human",
  text_expired: "Anti-Robot verification expired",
  button_restart: "Restart",
  text_error: "Verification failed",
  button_retry: "Retry",
  text_fetch_error: "Failed to connect to"
}; // French

var LANG_FR = {
  text_init: "Chargement..",
  text_ready: "Verification Anti-Robot",
  button_start: "Cliquez ici pour vérifier",
  text_fetching: "Chargement du challenge",
  text_solving: "Vérification que vous êtes humain..",
  text_completed: "Je suis humain",
  text_expired: "Verification échue",
  button_restart: "Recommencer",
  text_error: "Echec de verification",
  button_retry: "Recommencer",
  text_fetch_error: "Problème de connexion avec"
}; // German

var LANG_DE = {
  text_init: "Initialisierung..",
  text_ready: "Anti-Roboter-Verifizierung",
  button_start: "Hier klicken",
  text_fetching: "Herausforderung laden..",
  text_solving: "Verifizierung, dass Sie ein Mensch sind..",
  text_completed: "Ich bin ein Mensch",
  text_expired: "Verifizierung abgelaufen",
  button_restart: "Erneut starten",
  text_error: "Verifizierung fehlgeschlagen",
  button_retry: "Erneut versuchen",
  text_fetch_error: "Verbindungsproblem mit"
}; // Dutch

var LANG_NL = {
  text_init: "Initializeren..",
  text_ready: "Anti-robotverificatie",
  button_start: "Klik om te starten",
  text_fetching: "Aan het laden..",
  text_solving: "Anti-robotverificatie bezig..",
  text_completed: "Ik ben een mens",
  text_expired: "Verificatie verlopen",
  button_restart: "Opnieuw starten",
  text_error: "Verificatie mislukt",
  button_retry: "Opnieuw proberen",
  text_fetch_error: "Verbinding mislukt met"
}; // Italian

var LANG_IT = {
  text_init: "Inizializzazione...",
  text_ready: "Verifica Anti-Robot",
  button_start: "Clicca per iniziare",
  text_fetching: "Caricamento...",
  text_solving: "Verificando che sei umano...",
  text_completed: "Non sono un robot",
  text_expired: "Verifica Anti-Robot scaduta",
  button_restart: "Ricomincia",
  text_error: "Verifica fallita",
  button_retry: "Riprova",
  text_fetch_error: "Problema di connessione con"
}; // Portuguese

var LANG_PT = {
  text_init: "Inicializando..",
  text_ready: "Verificação Anti-Robô",
  button_start: "Clique para iniciar verificação",
  text_fetching: "Carregando..",
  text_solving: "Verificando se você é humano..",
  text_completed: "Eu sou humano",
  text_expired: "Verificação Anti-Robô expirada",
  button_restart: "Reiniciar",
  text_error: "Verificação falhou",
  button_retry: "Tentar novamente",
  text_fetch_error: "Falha de conexão com"
}; // Spanish

var LANG_ES = {
  text_init: "Inicializando..",
  text_ready: "Verificación Anti-Robot",
  button_start: "Haga clic para iniciar la verificación",
  text_fetching: "Cargando desafío",
  text_solving: "Verificando que eres humano..",
  text_completed: "Soy humano",
  text_expired: "Verificación Anti-Robot expirada",
  button_restart: "Reiniciar",
  text_error: "Ha fallado la verificación",
  button_retry: "Intentar de nuevo",
  text_fetch_error: "Error al conectarse a"
}; // Catalan

var LANG_CA = {
  text_init: "Inicialitzant...",
  text_ready: "Verificació Anti-Robot",
  button_start: "Fes clic per començar la verificació",
  text_fetching: "Carregant repte",
  text_solving: "Verificant que ets humà..",
  text_completed: "Soc humà",
  text_expired: "La verificació Anti-Robot ha expirat",
  button_restart: "Reiniciar",
  text_error: "Ha fallat la verificació",
  button_retry: "Tornar a provar",
  text_fetch_error: "Error connectant a"
}; // Japanese

var LANG_JA = {
  text_init: "開始しています...",
  text_ready: "アンチロボット認証",
  button_start: "クリックして認証を開始",
  text_fetching: "ロードしています",
  text_solving: "認証中...",
  text_completed: "私はロボットではありません",
  text_expired: "認証の期限が切れています",
  button_restart: "再度認証を行う",
  text_error: "認証にエラーが発生しました",
  button_retry: "再度認証を行う",
  text_fetch_error: "接続ができませんでした"
}; // Danish

var LANG_DA = {
  text_init: "Initialiserer..",
  text_ready: "Anti-robot verifikation",
  button_start: "Klik for at starte verifikationen",
  text_fetching: "Henter udfordring",
  text_solving: "Bekræfter, at du er menneske..",
  text_completed: "Jeg er menneske",
  text_expired: "Anti-Robot-verifikation er udløbet",
  button_restart: "Genstart",
  text_error: "Bekræftelse mislykkedes",
  button_retry: "Prøv igen",
  text_fetch_error: "Det lykkedes ikke at oprette forbindelse til"
};
var localizations = {
  en: LANG_EN,
  de: LANG_DE,
  nl: LANG_NL,
  fr: LANG_FR,
  it: LANG_IT,
  pt: LANG_PT,
  es: LANG_ES,
  ca: LANG_CA,
  ja: LANG_JA,
  da: LANG_DA
};

function createDiagnosticsBuffer(solverID, timeToSolved) {
  var arr = new Uint8Array(3);
  var view = new DataView(arr.buffer);
  view.setUint8(0, solverID);
  view.setUint16(1, timeToSolved);
  return arr;
}

var workerString = "!function(){\"use strict\";const A=\"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/\",I=\"=\".charCodeAt(0),g=new Uint8Array(256);for(let I=0;I<A.length;I++)g[A.charCodeAt(I)]=I;function C(A){const I={},g=A.exports,C=g.memory,t=g.__alloc,B=g.__retain,Q=g.__rtti_base||-1;return I.__allocArray=(A,I)=>{const g=function(A){return new Uint32Array(C.buffer)[(Q+4>>>2)+2*A]}(A),e=31-Math.clz32(g>>>6&31),r=I.length,i=t(r<<e,0),o=t(12,A),n=new Uint32Array(C.buffer);n[o+0>>>2]=B(i),n[o+4>>>2]=i,n[o+8>>>2]=r<<e;const E=C.buffer,s=new Uint8Array(E);if(16384&g)for(let A=0;A<r;++A)s[(i>>>e)+A]=B(I[A]);else s.set(I,i>>>e);return o},I.__getUint8Array=A=>{const I=new Uint32Array(C.buffer),g=I[A+4>>>2];return new Uint8Array(C.buffer,g,I[g-4>>>2]>>>0)},function(A,I={}){const g=A.__argumentsLength?I=>{A.__argumentsLength.value=I}:A.__setArgumentsLength||A.__setargc||(()=>({}));for(const C in A){if(!Object.prototype.hasOwnProperty.call(A,C))continue;const t=A[C],B=C.split(\".\")[0];\"function\"==typeof t&&t!==g?(I[B]=(...A)=>(g(A.length),t(...A))).original=t:I[B]=t}return I}(g,I)}class t{constructor(A){this.b=new Uint8Array(128),this.h=new Uint32Array(16),this.t=0,this.c=0,this.v=new Uint32Array(32),this.m=new Uint32Array(32),this.outlen=A}}function B(A,I){return A[I]^A[I+1]<<8^A[I+2]<<16^A[I+3]<<24}function Q(A,I,g,C,t,B,Q,e){const r=I[Q],i=I[Q+1],o=I[e],n=I[e+1];let E,s,w,a,c=A[g],D=A[g+1],f=A[C],h=A[C+1],l=A[t],y=A[t+1],U=A[B],M=A[B+1];E=c+f,s=(c&f|(c|f)&~E)>>>31,c=E,D=D+h+s,E=c+r,s=(c&r|(c|r)&~E)>>>31,c=E,D=D+i+s,w=U^c,a=M^D,U=a,M=w,E=l+U,s=(l&U|(l|U)&~E)>>>31,l=E,y=y+M+s,w=f^l,a=h^y,f=w>>>24^a<<8,h=a>>>24^w<<8,E=c+f,s=(c&f|(c|f)&~E)>>>31,c=E,D=D+h+s,E=c+o,s=(c&o|(c|o)&~E)>>>31,c=E,D=D+n+s,w=U^c,a=M^D,U=w>>>16^a<<16,M=a>>>16^w<<16,E=l+U,s=(l&U|(l|U)&~E)>>>31,l=E,y=y+M+s,w=f^l,a=h^y,f=a>>>31^w<<1,h=w>>>31^a<<1,A[g]=c,A[g+1]=D,A[C]=f,A[C+1]=h,A[t]=l,A[t+1]=y,A[B]=U,A[B+1]=M}const e=[4089235720,1779033703,2227873595,3144134277,4271175723,1013904242,1595750129,2773480762,2917565137,1359893119,725511199,2600822924,4215389547,528734635,327033209,1541459225],r=[0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,28,20,8,16,18,30,26,12,2,24,0,4,22,14,10,6,22,16,24,0,10,4,30,26,20,28,6,12,14,2,18,8,14,18,6,2,26,24,22,28,4,12,10,20,8,0,30,16,18,0,10,14,4,8,20,30,28,2,22,24,12,16,6,26,4,24,12,20,0,22,16,6,8,26,14,10,30,28,2,18,24,10,2,30,28,26,8,20,0,14,12,6,18,4,16,22,26,22,14,28,24,2,6,18,10,0,30,8,16,12,4,20,12,30,28,18,22,6,0,16,24,4,26,14,2,8,20,10,20,4,16,8,14,12,2,10,30,22,18,28,6,24,26,0,0,2,4,6,8,10,12,14,16,18,20,22,24,26,28,30,28,20,8,16,18,30,26,12,2,24,0,4,22,14,10,6];function i(A,I){const g=A.v,C=A.m;for(let I=0;I<16;I++)g[I]=A.h[I],g[I+16]=e[I];g[24]=g[24]^A.t,g[25]=g[25]^A.t/4294967296,I&&(g[28]=~g[28],g[29]=~g[29]);for(let I=0;I<32;I++)C[I]=B(A.b,4*I);for(let A=0;A<12;A++)Q(g,C,0,8,16,24,r[16*A+0],r[16*A+1]),Q(g,C,2,10,18,26,r[16*A+2],r[16*A+3]),Q(g,C,4,12,20,28,r[16*A+4],r[16*A+5]),Q(g,C,6,14,22,30,r[16*A+6],r[16*A+7]),Q(g,C,0,10,20,30,r[16*A+8],r[16*A+9]),Q(g,C,2,12,22,24,r[16*A+10],r[16*A+11]),Q(g,C,4,14,16,26,r[16*A+12],r[16*A+13]),Q(g,C,6,8,18,28,r[16*A+14],r[16*A+15]);for(let I=0;I<16;I++)A.h[I]=A.h[I]^g[I]^g[I+16]}function o(A,I){for(let I=0;I<16;I++)A.h[I]=e[I];A.b.set(I),A.h[0]^=16842752^A.outlen}async function n(){return(A,I,g=4294967295)=>[A,function(A,I,g){if(128!=A.length)throw Error(\"Invalid input\");const C=A.buffer,B=new DataView(C),Q=new t(32);Q.t=128;const e=B.getUint32(124,!0),r=e+g;for(let g=e;g<r;g++)if(B.setUint32(124,g,!0),o(Q,A),i(Q,!0),Q.h[0]<I)return 0==ASC_TARGET?new Uint8Array(Q.h.buffer):Uint8Array.wrap(Q.h.buffer);return new Uint8Array(0)}(A,I,g)]}let E,s;Uint8Array.prototype.slice||Object.defineProperty(Uint8Array.prototype,\"slice\",{value:function(A,I){return new Uint8Array(Array.prototype.slice.call(this,A,I))}}),self.ASC_TARGET=0;const w=new Promise((A=>s=A));let a=!1;self.onerror=A=>{self.postMessage({type:\"error\",message:JSON.stringify(A)})},self.onmessage=async A=>{const t=A.data;try{if(\"solver\"===t.type){if(t.forceJS){E=1;const A=await n();s(A)}else try{E=2;const A=WebAssembly.compile(function(A){const C=A.length;let t=3*C>>>2;A.charCodeAt(C-1)===I&&t--,A.charCodeAt(C-2)===I&&t--;const B=new Uint8Array(t);for(let I=0,t=0;I<C;I+=4){const C=g[A.charCodeAt(I+0)],Q=g[A.charCodeAt(I+1)],e=g[A.charCodeAt(I+2)],r=g[A.charCodeAt(I+3)];B[t++]=C<<2|Q>>4,B[t++]=(15&Q)<<4|e>>2,B[t++]=(3&e)<<6|63&r}return B}(\"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\")),t=await async function(A){const I=await async function(A){const I={env:{abort(){throw Error(\"Wasm aborted\")}}};return{exports:C(await WebAssembly.instantiate(A,I))}}(A),g=I.exports.__retain(I.exports.__allocArray(I.exports.Uint8Array_ID,new Uint8Array(128)));let t=I.exports.__getUint8Array(g);return(A,C,B=4294967295)=>{t.set(A);const Q=I.exports.solveBlake2b(g,C,B);t=I.exports.__getUint8Array(g);const e=I.exports.__getUint8Array(Q);return I.exports.__release(Q),[t,e]}}(await A);s(t)}catch(A){console.log(\"FriendlyCaptcha failed to initialize WebAssembly, falling back to Javascript solver: \"+A.toString()),E=1;const I=await n();s(I)}self.postMessage({type:\"ready\",solver:E})}else if(\"start\"===t.type){if(a)return;a=!0;const A=await w;self.postMessage({type:\"started\"});let I=0;const g=t.puzzleSolverInputs,C=new Uint8Array(8*t.n);for(let B=t.startIndex;B<g.length;B+=t.numWorkers){let Q;for(let C=0;C<256;C++){g[B][123]=C;const[e,r]=A(g[B],t.threshold);if(0!==r.length){Q=e;break}console.warn(\"FC: Internal error or no solution found\"),I+=Math.pow(2,32)-1}const e=new DataView(Q.slice(-4).buffer).getUint32(0,!0);I+=e,C.set(Q.slice(-8),8*B),self.postMessage({type:\"progress\",h:e})}const B={type:\"done\",solution:C,totalH:I,startIndex:t.startIndex};self.postMessage(B)}}catch(A){setTimeout((()=>{throw A}))}}}();"; // Defensive init to make it easier to integrate with Gatsby and friends.

var URL;

if (typeof window !== "undefined") {
  URL = window.URL || window.webkitURL;
}

var WorkerGroup = /*#__PURE__*/function () {
  function WorkerGroup() {
    _classCallCheck(this, WorkerGroup);

    this.workers = [];
    this.numPuzzles = 0;
    this.startTime = 0;
    this.progress = 0;
    this.totalHashes = 0;
    this.puzzleSolverInputs = [];
    this.solutionBuffer = new Uint8Array(0); // initialize some value, so ts is happy

    this.solverType = 1;
    this.readyCount = 0;
    this.startCount = 0;
    this.doneCount = 0;

    this.progressCallback = function () {
      return 0;
    };

    this.readyCallback = function () {
      return 0;
    };

    this.startedCallback = function () {
      return 0;
    };

    this.doneCallback = function () {
      return 0;
    };

    this.errorCallback = function () {
      return 0;
    };
  }

  _createClass(WorkerGroup, [{
    key: "init",
    value: function init() {
      var _this = this;

      if (this.workers.length > 0) {
        for (var _i4 = 0; _i4 < this.workers.length; _i4++) {
          this.workers[_i4].terminate();
        }
      }

      this.progress = 0;
      this.totalHashes = 0;
      this.readyCount = 0;
      this.startCount = 0;
      this.doneCount = 0; // Setup four workers for now - later we could calculate this depending on the device

      this.workers = new Array(4);
      var workerBlob = new Blob([workerString], {
        type: "text/javascript"
      });

      for (var _i5 = 0; _i5 < this.workers.length; _i5++) {
        this.workers[_i5] = new Worker(URL.createObjectURL(workerBlob));

        this.workers[_i5].onerror = function (e) {
          return _this.errorCallback(e);
        };

        this.workers[_i5].onmessage = function (e) {
          var data = e.data;
          if (!data) return;

          if (data.type === "progress") {
            _this.progress++;
            _this.totalHashes += data.h;

            _this.progressCallback({
              n: _this.numPuzzles,
              h: _this.totalHashes,
              t: (Date.now() - _this.startTime) / 1000,
              i: _this.progress
            });
          } else if (data.type === "ready") {
            _this.readyCount++;
            _this.solverType = data.solver; // We are ready, when all workers are ready

            if (_this.readyCount == _this.workers.length) {
              _this.readyCallback();
            }
          } else if (data.type === "started") {
            _this.startCount++; // We started, when the first worker starts working

            if (_this.startCount == 1) {
              _this.startTime = Date.now();

              _this.startedCallback();
            }
          } else if (data.type === "done") {
            _this.doneCount++;

            for (var _i6 = data.startIndex; _i6 < _this.puzzleSolverInputs.length; _i6 += _this.workers.length) {
              _this.solutionBuffer.set(data.solution.subarray(_i6 * 8, _i6 * 8 + 8), _i6 * 8);
            } // We are done, when all workers are done


            if (_this.doneCount == _this.workers.length) {
              var totalTime = (Date.now() - _this.startTime) / 1000;

              _this.doneCallback({
                solution: _this.solutionBuffer,
                h: _this.totalHashes,
                t: totalTime,
                diagnostics: createDiagnosticsBuffer(_this.solverType, totalTime),
                solver: _this.solverType
              });
            }
          } else if (data.type === "error") {
            _this.errorCallback(data);
          }
        };
      }
    }
  }, {
    key: "setupSolver",
    value: function setupSolver() {
      var forceJS = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var msg = {
        type: "solver",
        forceJS: forceJS
      };

      for (var _i7 = 0; _i7 < this.workers.length; _i7++) {
        this.workers[_i7].postMessage(msg);
      }
    }
  }, {
    key: "start",
    value: function start(puzzle) {
      this.puzzleSolverInputs = getPuzzleSolverInputs(puzzle.buffer, puzzle.n);
      this.solutionBuffer = new Uint8Array(8 * puzzle.n);
      this.numPuzzles = puzzle.n;

      for (var _i8 = 0; _i8 < this.workers.length; _i8++) {
        this.workers[_i8].postMessage({
          type: "start",
          puzzleSolverInputs: this.puzzleSolverInputs,
          threshold: puzzle.threshold,
          n: puzzle.n,
          numWorkers: this.workers.length,
          startIndex: _i8
        });
      }
    }
  }, {
    key: "terminateWorkers",
    value: function terminateWorkers() {
      if (this.workers.length == 0) return;

      for (var _i9 = 0; _i9 < this.workers.length; _i9++) {
        this.workers[_i9].terminate();
      }

      this.workers = [];
    }
  }]);

  return WorkerGroup;
}();

var PUZZLE_ENDPOINT_URL = "https://api.friendlycaptcha.com/api/v1/puzzle";

var WidgetInstance = /*#__PURE__*/function () {
  function WidgetInstance(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, WidgetInstance);

    this.workerGroup = new WorkerGroup();
    /**
     * The captcha has been succesfully solved.
     */

    this.valid = false;
    /**
     * Some errors may cause a need for the (worker) to be reinitialized. If this is
     * true `init` will be called again when start is called.
     */

    this.needsReInit = false;
    /**
     * Start() has been called at least once ever.
     */

    this.hasBeenStarted = false;
    this.hasBeenDestroyed = false;
    this.opts = Object.assign({
      forceJSFallback: false,
      startMode: "focus",
      puzzleEndpoint: element.dataset["puzzleEndpoint"] || PUZZLE_ENDPOINT_URL,
      startedCallback: function startedCallback() {
        return 0;
      },
      readyCallback: function readyCallback() {
        return 0;
      },
      doneCallback: function doneCallback() {
        return 0;
      },
      errorCallback: function errorCallback() {
        return 0;
      },
      sitekey: element.dataset["sitekey"] || "",
      language: element.dataset["lang"] || "en",
      solutionFieldName: element.dataset["solutionFieldName"] || "frc-captcha-solution"
    }, options);
    this.e = element; // Load language

    if (typeof this.opts.language === "string") {
      var l = localizations[this.opts.language.toLowerCase()];

      if (l === undefined) {
        console.error('FriendlyCaptcha: language "' + this.opts.language + '" not found.'); // Fall back to English

        l = localizations.en;
      }

      this.lang = l;
    } else {
      // We assign to a copy of the English language localization, so that any missing values will be English
      this.lang = Object.assign(Object.assign({}, localizations.en), this.opts.language);
    }

    element.innerText = this.lang.text_init;
    injectStyle();
    this.init(this.opts.startMode === "auto" || this.e.dataset["start"] === "auto");
  }

  _createClass(WidgetInstance, [{
    key: "init",
    value: function init(forceStart) {
      var _this2 = this;

      if (this.hasBeenDestroyed) {
        console.error("FriendlyCaptcha widget has been destroyed using destroy(), it can not be used anymore.");
        return;
      }

      this.initWorkerGroup();

      if (forceStart) {
        this.start();
      } else if (this.e.dataset["start"] !== "none" && (this.opts.startMode === "focus" || this.e.dataset["start"] === "focus")) {
        var form = findParentFormElement(this.e);

        if (form) {
          executeOnceOnFocusInEvent(form, function () {
            if (!_this2.hasBeenStarted) {
              _this2.start();
            }
          });
        } else {
          console.log("FriendlyCaptcha div seems not to be contained in a form, autostart will not work");
        }
      }
    }
    /**
     * Add a listener to the button that calls `this.start` on click.
     */

  }, {
    key: "makeButtonStart",
    value: function makeButtonStart() {
      var _this3 = this;

      var b = this.e.querySelector("button");

      if (b) {
        b.addEventListener("click", function (e) {
          return _this3.start();
        }, {
          once: true,
          passive: true
        });
        b.addEventListener("touchstart", function (e) {
          return _this3.start();
        }, {
          once: true,
          passive: true
        });
      }
    }
  }, {
    key: "onWorkerError",
    value: function onWorkerError(e) {
      this.needsReInit = true;
      this.e.innerHTML = getErrorHTML(this.opts.solutionFieldName, this.lang, "Background worker error " + e.message);
      this.makeButtonStart(); // Just out of precaution

      this.opts.forceJSFallback = true;
    }
  }, {
    key: "initWorkerGroup",
    value: function initWorkerGroup() {
      var _this4 = this;

      this.workerGroup.progressCallback = function (progress) {
        updateProgressBar(_this4.e, progress);
      };

      this.workerGroup.readyCallback = function () {
        _this4.e.innerHTML = getReadyHTML(_this4.opts.solutionFieldName, _this4.lang);

        _this4.makeButtonStart();

        _this4.opts.readyCallback();
      };

      this.workerGroup.startedCallback = function () {
        _this4.e.innerHTML = getRunningHTML(_this4.opts.solutionFieldName, _this4.lang);

        _this4.opts.startedCallback();
      };

      this.workerGroup.doneCallback = function (data) {
        var solutionPayload = _this4.handleDone(data);

        _this4.opts.doneCallback(solutionPayload);

        var callback = _this4.e.dataset["callback"];

        if (callback) {
          window[callback](solutionPayload);
        }
      };

      this.workerGroup.errorCallback = function (e) {
        _this4.onWorkerError(e);
      };

      this.workerGroup.init();
      this.workerGroup.setupSolver(this.opts.forceJSFallback);
    }
  }, {
    key: "expire",
    value: function expire() {
      this.e.innerHTML = getExpiredHTML(this.opts.solutionFieldName, this.lang);
      this.makeButtonStart();
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this5 = this;

        var sitekey, code, callback;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.hasBeenDestroyed) {
                  _context.next = 3;
                  break;
                }

                console.error("Can not start FriendlyCaptcha widget which has been destroyed");
                return _context.abrupt("return");

              case 3:
                this.hasBeenStarted = true;
                sitekey = this.opts.sitekey || this.e.dataset["sitekey"];

                if (sitekey) {
                  _context.next = 9;
                  break;
                }

                console.error("FriendlyCaptcha: sitekey not set on frc-captcha element");
                this.e.innerHTML = getErrorHTML(this.opts.solutionFieldName, this.lang, "Website problem: sitekey not set", false);
                return _context.abrupt("return");

              case 9:
                if (!isHeadless()) {
                  _context.next = 12;
                  break;
                }

                this.e.innerHTML = getErrorHTML(this.opts.solutionFieldName, this.lang, "Browser check failed, try a different browser", false, true);
                return _context.abrupt("return");

              case 12:
                if (!this.needsReInit) {
                  _context.next = 16;
                  break;
                }

                this.needsReInit = false;
                this.init(true);
                return _context.abrupt("return");

              case 16:
                _context.prev = 16;
                this.e.innerHTML = getFetchingHTML(this.opts.solutionFieldName, this.lang);
                _context.t0 = decodeBase64Puzzle;
                _context.next = 21;
                return getPuzzle(this.opts.puzzleEndpoint, sitekey, this.lang);

              case 21:
                _context.t1 = _context.sent;
                this.puzzle = (0, _context.t0)(_context.t1);
                setTimeout(function () {
                  return _this5.expire();
                }, this.puzzle.expiry - 30000); // 30s grace

                _context.next = 35;
                break;

              case 26:
                _context.prev = 26;
                _context.t2 = _context["catch"](16);
                this.e.innerHTML = getErrorHTML(this.opts.solutionFieldName, this.lang, _context.t2.message);
                this.makeButtonStart();
                code = "error_getting_puzzle";
                this.opts.errorCallback({
                  code: code,
                  description: _context.t2.toString(),
                  error: _context.t2
                });
                callback = this.e.dataset["callback-error"];

                if (callback) {
                  window[callback](this);
                }

                return _context.abrupt("return");

              case 35:
                this.workerGroup.start(this.puzzle);

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[16, 26]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
    /**
     * This is to be called when the puzzle has been succesfully completed.
     * Here the hidden field gets updated with the solution.
     * @param data message from the webworker
     */

  }, {
    key: "handleDone",
    value: function handleDone(data) {
      this.valid = true;
      var puzzleSolutionMessage = "".concat(this.puzzle.signature, ".").concat(this.puzzle.base64, ".").concat(encode(data.solution), ".").concat(encode(data.diagnostics));
      this.e.innerHTML = getDoneHTML(this.opts.solutionFieldName, this.lang, puzzleSolutionMessage, data); // this.worker = null; // This literally crashes very old browsers..

      this.needsReInit = true;
      return puzzleSolutionMessage;
    }
    /**
     * Cleans up the widget entirely, removing any DOM elements and terminating any background workers.
     * After it is destroyed it can no longer be used for any purpose.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.workerGroup.terminateWorkers();
      this.needsReInit = false;
      this.hasBeenStarted = false;

      if (this.e) {
        this.e.remove(); // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore

        delete this.e;
      }

      this.hasBeenDestroyed = true;
    }
    /**
     * Resets the widget to the initial state.
     * This is useful in situations where the page does not refresh when you submit and the form may be re-submitted again
     */

  }, {
    key: "reset",
    value: function reset() {
      if (this.hasBeenDestroyed) {
        console.error("FriendlyCaptcha widget has been destroyed, it can not be used anymore");
        return;
      }

      this.workerGroup.terminateWorkers();
      this.needsReInit = false;
      this.hasBeenStarted = false;
      this.init(this.opts.startMode === "auto" || this.e.dataset["start"] === "auto");
    }
  }]);

  return WidgetInstance;
}();


;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40[0].rules[0].use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/VueFriendlyCaptcha.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//

/* harmony default export */ var VueFriendlyCaptchavue_type_script_lang_js_ = ({
  name: 'VueFriendlyCaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    dark: {
      type: Boolean,
      default: false
    },
    startMode: {
      type: String,
      default: 'focus'
    },
    language: {
      type: String,
      default: 'en'
    },
    solutionFieldName: {
      type: String,
      default: 'frc-captcha-solution'
    },
    puzzleEndpoint: {
      type: String,
      default: 'https://api.friendlycaptcha.com/api/v1/puzzle'
    }
  },
  data: function data() {
    return {
      widget: null
    };
  },
  mounted: function mounted() {
    if (!this.widget) {
      this.widget = new WidgetInstance(this.$refs.captcha, {
        sitekey: this.sitekey,
        startMode: this.startMode,
        language: this.language,
        solutionFieldName: this.solutionFieldName,
        puzzleEndpoint: this.puzzleEndpoint,
        readyCallback: this.onReady.bind(this),
        startedCallback: this.onStarted.bind(this),
        doneCallback: this.onDone.bind(this),
        errorCallback: this.onError.bind(this)
      });
    }
  },
  destroyed: function destroyed() {
    if (this.widget) {
      this.widget.destroy();
    }
  },
  methods: {
    onReady: function onReady() {
      this.$emit('ready');
    },
    onStarted: function onStarted() {
      this.$emit('started');
    },
    onDone: function onDone(solution) {
      this.$emit('done', solution);
    },
    onError: function onError(error) {
      this.$emit('error', error);
    },
    init: function init() {
      var _this$widget;

      (_this$widget = this.widget) === null || _this$widget === void 0 ? void 0 : _this$widget.init();
    },
    start: function start() {
      var _this$widget2;

      (_this$widget2 = this.widget) === null || _this$widget2 === void 0 ? void 0 : _this$widget2.start();
    },
    reset: function reset() {
      var _this$widget3;

      (_this$widget3 = this.widget) === null || _this$widget3 === void 0 ? void 0 : _this$widget3.reset();
    },
    destroy: function destroy() {
      var _this$widget4;

      (_this$widget4 = this.widget) === null || _this$widget4 === void 0 ? void 0 : _this$widget4.destroy();
    },
    isValid: function isValid() {
      var _this$widget5;

      return ((_this$widget5 = this.widget) === null || _this$widget5 === void 0 ? void 0 : _this$widget5.valid) || false;
    }
  }
});
;// CONCATENATED MODULE: ./src/VueFriendlyCaptcha.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_VueFriendlyCaptchavue_type_script_lang_js_ = (VueFriendlyCaptchavue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/VueFriendlyCaptcha.vue





/* normalize component */
;
var component = normalizeComponent(
  src_VueFriendlyCaptchavue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VueFriendlyCaptcha = (component.exports);
;// CONCATENATED MODULE: ./src/main.js


VueFriendlyCaptcha.install = function (Vue) {
  Vue.component('VueFriendlyCaptcha', VueFriendlyCaptcha);
};

/* harmony default export */ var main = (VueFriendlyCaptcha);
;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = (main);


}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=vue-friendly-captcha.common.js.map